import { getDay, getHours, isBefore, setHours, setMinutes } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

export default function isGearExpertsOnlineScheduled(
  now = utcToZonedTime(new Date(), 'America/New_York'),
) {
  const hour = getHours(now);
  const day = getDay(now);

  const closeTime = setHours(setMinutes(now, 45), 21);

  if (
    hour >= 12 &&
    isBefore(now, closeTime) &&
    (day == 0 || day == 1 || day == 2 || day == 4)
  ) {
    return true;
  }

  return false;
}
